/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_State_ExpiredInputs */

const en_signin_state_expired = /** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in link has expired. Ask for a new one.`)
};

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const ar_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const he_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const ur_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const es_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const fr_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const de_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const pt_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const hi_signin_state_expired = en_signin_state_expired;

/** @type {(inputs: Signin_State_ExpiredInputs) => LocalizedString} */
const bn_signin_state_expired = en_signin_state_expired;

/**
* | output |
* | --- |
* | "This sign-in link has expired. Ask for a new one." |
*
* @param {Signin_State_ExpiredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_state_expired = /** @type {((inputs?: Signin_State_ExpiredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_State_ExpiredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_state_expired(inputs)
	if (locale === "he") return he_signin_state_expired(inputs)
	if (locale === "ur") return ur_signin_state_expired(inputs)
	if (locale === "es") return es_signin_state_expired(inputs)
	if (locale === "fr") return fr_signin_state_expired(inputs)
	if (locale === "de") return de_signin_state_expired(inputs)
	if (locale === "pt") return pt_signin_state_expired(inputs)
	if (locale === "hi") return hi_signin_state_expired(inputs)
	if (locale === "bn") return bn_signin_state_expired(inputs)
	return /** @type {LocalizedString} */ ("This sign-in link has expired. Ask for a new one.")
});